"use client";

import { type CSSProperties, useEffect, useState } from "react";
import styles from "./SetupBrandTitle.module.css";

const BRAND = "CHICKYTUTOR";
const GLYPHS = "こんエこにソてしての尺";

interface SetupBrandTitleProps {
  enabled: boolean;
  reduceMotion: boolean | null;
}

export function SetupBrandTitle({ enabled, reduceMotion }: SetupBrandTitleProps) {
  const [revealed, setRevealed] = useState(false);
  const canAnimate = enabled && reduceMotion === false;

  useEffect(() => {
    if (!canAnimate) setRevealed(false);
  }, [canAnimate]);

  return (
    <div className={`${styles.frame} text-4xl font-black text-white lg:text-5xl xl:text-6xl`}>
      <button
        type="button"
        className={styles.trigger}
        aria-label="Animate ChickyTutor title"
        disabled={!canAnimate}
        onPointerEnter={(event) => {
          if (canAnimate && event.pointerType !== "touch") setRevealed(true);
        }}
        onPointerLeave={(event) => {
          if (event.pointerType !== "touch") setRevealed(false);
        }}
        onPointerUp={(event) => {
          if (canAnimate && event.pointerType === "touch") setRevealed((current) => !current);
        }}
        onFocus={(event) => {
          if (canAnimate && event.currentTarget.matches(":focus-visible")) setRevealed(true);
        }}
        onBlur={() => setRevealed(false)}
        onClick={(event) => {
          if (canAnimate && event.detail === 0) setRevealed(true);
        }}
        onKeyDown={(event) => {
          if (event.key === "Escape") setRevealed(false);
        }}
      >
        <span
          aria-hidden="true"
          className={styles.title}
          data-motion={canAnimate ? "enabled" : "disabled"}
          data-revealed={canAnimate && revealed}
        >
          {Array.from(BRAND, (letter, index) => (
            <span
              key={index}
              className={`${styles.letter} ${index >= 6 ? "text-orange-400" : ""}`}
              style={{ "--letter-delay": `${index * 80}ms` } as CSSProperties}
            >
              <span className={styles.latin}>{letter}</span>
              <span className={styles.glyph}>{GLYPHS[index]}</span>
            </span>
          ))}
        </span>
      </button>
    </div>
  );
}
